import classNames from 'classnames';
import { RenderRadio } from 'forms';
import React from 'react';
import { Field, FormSpy } from 'react-final-form';
import { Table } from 'semantic-ui-react';

interface Props {
    value: string;
    title: string;
    name: string;
    fields: string[];
    medium?: boolean;
    defaultValue?: string;
}

export default function SelectableTableHeaderCell({
    value,
    title,
    fields,
    name,
    medium = false,
    defaultValue
}: Props): React.ReactElement {
    return (
        <Table.HeaderCell
            className={classNames('table-header-cell', {
                medium
            })}
            value={value}
        >
            <div className="table-header-cell-inner center">
                <span className="selectable-title">{title}</span>
                <FormSpy>
                    {(formProps): React.ReactElement => (
                        <Field
                            component={RenderRadio as any}
                            id={value}
                            name={name}
                            value={value}
                            type="radio"
                            className="round-checkbox"
                            onClick={() =>
                                fields.map((field) =>
                                    formProps.form.change(field, value)
                                )
                            }
                            defaultValue={defaultValue}
                        />
                    )}
                </FormSpy>
            </div>
        </Table.HeaderCell>
    );
}
